export default function PHP_date_format() {
  return (
    <div>
      <h1>PHP_date_format</h1>
    </div>
  );
}
